import { Metadata } from "next";
import { removeTags } from ".";
import { StaticImageData } from "next/image";
import { isArray } from "util";
import { WEBSITE_BASE_URL } from "@/app/constant";

interface OptionsArgs {
  titleKeyName: string;
  indexKeyName: string;
  imageKeyName: string;
  descriptionKeyname: string;
  isDescritionArray?: boolean;
  keywords?: string | string[];
  root: string;
}

const getMetaData = (
  data: any,
  {
    root,
    titleKeyName,
    indexKeyName,
    imageKeyName,
    descriptionKeyname,
    isDescritionArray,
    keywords,
  }: OptionsArgs
): Metadata => {
  const title = data[titleKeyName];
  const description =
    isDescritionArray || isArray(data[descriptionKeyname])
      ? (data[descriptionKeyname] || [])
          .map((el: string) => removeTags(el))
          .join(" ")
      : removeTags(data[descriptionKeyname]);
  return {
    title,
    description,
    keywords,
    alternates: {
      canonical: `${WEBSITE_BASE_URL}/${root}/${data[indexKeyName]}`,
    },
    openGraph: {
      title,
      url: `/${root}/${data[indexKeyName]}`,
      description,
      images: [
        {
          url:
            typeof data[imageKeyName] === "string"
              ? data[imageKeyName]
              : (data[imageKeyName] as StaticImageData).src,
        },
      ],
    },
  };
};

export default getMetaData;
